import React from 'react';
import { styled } from '@mui/material';
import { AvailableTeacher } from 'models';
import Availability from './Availability';
import AvailableTeacherCardHeader from './AvailableTeacherCardHeader';
import { Card, Grid } from 'library/ui';

export default function AvailableTeacherCard({
    teacher,
    requestToBook,
}: {
    teacher: AvailableTeacher;
    requestToBook: (teacher: AvailableTeacher, lower: string, upper: string, timezone?: string) => void;
}) {
    return (
        <RowCard padding="sm">
            <Grid template="280px minmax(0, 1fr)" collapseAt="md" gap="lg" align="center">
                <AvailableTeacherCardHeader worker={teacher} />
                <SlotScroller>
                    <Availability teacher={teacher} requestToBook={requestToBook} />
                </SlotScroller>
            </Grid>
        </RowCard>
    );
}

const RowCard = styled(Card)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        height: 136,
    },
}));

const SlotScroller = styled('div')({
    minWidth: 0,
    overflowX: 'auto',
    padding: 16,
    margin: -16,
});
